var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.user !== null
    ? _c("tm-group-grid", {
        ref: "grid",
        staticClass: "flex-grow",
        attrs: {
          token: _vm.verificationToken,
          "api-root": _vm.apiRoot,
          jwt: _setup.token,
          "current-user": _setup.user,
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }